var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-body-extra-small',_vm._g({staticClass:"pc-sign-up__text-error",attrs:{"line-height":"lh-lg"}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }